var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth-callback-wrapper"},[_c('h2',[_vm._v("Completing Google sign-in...")]),_c('md-progress-spinner',{attrs:{"md-diameter":40,"md-stroke":4,"md-mode":"indeterminate"}}),(_vm.serverError)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }